import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  boardSearch: "",
};

const boardSlice = createSlice({
  name: "boardSlice",
  initialState,
  reducers: {
    saveboardSearch: (state, action) => {
      state.boardSearch = action.payload;
    },
  },
});

export const { saveboardSearch } = boardSlice.actions;
export default boardSlice.reducer;
